"use strict";

angular
    .module('material.components.datepicker')
    .config(['$provide', function ($provide) {

        $provide.decorator('mdCalendarDirective', ['$delegate', function ( $delegate ) {

            let directive = $delegate[0];
            directive.scope.triggerMonthIndex = '=rmTriggerMonthIndex';
            directive.scope.dateFilterUpdateCtrl = '=rmDateFilterUpdate';

            var link = function(scope, element, attrs, controllers) {

                var ngModelCtrl = controllers[0];
                var mdCalendarCtrl = controllers[1];
                mdCalendarCtrl.configureNgModel(ngModelCtrl);
            }

            $delegate[0].compile = function() {

                return function(scope, element, attrs, ctrls) {

                    link.apply(this, arguments);
                };
            };

            return $delegate;
        }] )

        $provide.decorator('mdCalendarMonthBodyDirective', ['$delegate', '$$mdSvgRegistry', '$compile', '$$mdDateUtil', function ($delegate, $$mdSvgRegistry, $compile, $$mdDateUtil) {

            var ARROW_ICON = $compile('<md-icon md-svg-src="' +
                $$mdSvgRegistry.mdTabsArrow + '"></md-icon>')({})[0];

            var link = function(scope, element, attrs, controllers) {

                var calendarCtrl = controllers[0];
                var monthCtrl = controllers[1];
                var monthBodyCtrl = controllers[2];


                monthBodyCtrl.calendarCtrl = calendarCtrl;
                monthBodyCtrl.monthCtrl = monthCtrl;
                monthBodyCtrl.arrowIcon = ARROW_ICON.cloneNode(true);

                scope.$watch(function() { return monthBodyCtrl.offset; }, function(offset) {

                    if (angular.isNumber(offset)) {
                        if (calendarCtrl.triggerMonthIndex) {
                            calendarCtrl.triggerMonthIndex( monthBodyCtrl );
                        }
                    }

                    monthBodyCtrl.generateContent();
                });

                calendarCtrl.dateFilterUpdate = calendarCtrl.dateFilterUpdateCtrl || {};
                calendarCtrl.dateFilterUpdate.generateContent = ( monthBodyCtrlParam ) => {

                    monthBodyCtrlParam.generateContent();
                }
            }

            $delegate[0].compile = function() {

                return function(scope, element, attrs, ctrls) {

                    link.apply(this, arguments);
                };
            };

            return $delegate;
        } ] );
    }]);

